import { render } from "./test_rectangle.vue?vue&type=template&id=d57a5ab2&scoped=true"
import script from "./test_rectangle.vue?vue&type=script&lang=js"
export * from "./test_rectangle.vue?vue&type=script&lang=js"

import "./test_rectangle.vue?vue&type=style&index=0&id=d57a5ab2&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d57a5ab2"]])

export default __exports__